import axios from 'axios';
import { Mail, Trash2, Copy } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function SubscribersManager({ subscribers, onRefresh, headers }) {
    const handleDelete = async (id) => {
        if (!window.confirm('Remove this subscriber?')) return;
        try {
            await axios.delete(`${API}/subscribers/${id}`, { headers });
            toast.success('Subscriber removed!');
            onRefresh();
        } catch (error) {
            toast.error('Failed to remove');
        }
    };

    const handleExport = async () => {
        try {
            const response = await axios.get(`${API}/subscribers/export`, { headers });
            const emails = response.data.emails.join('\n');
            navigator.clipboard.writeText(emails);
            toast.success(`${response.data.count} emails copied to clipboard!`);
        } catch (error) {
            toast.error('Failed to export');
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    return (
        <div className="retro-card p-6" data-testid="subscribers-manager">
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h2 className="text-lg uppercase tracking-tight" style={{ fontFamily: "'Silkscreen', cursive" }}>
                        Newsletter Subscribers
                    </h2>
                    <p className="text-sm text-muted-foreground">{subscribers.length} subscribers</p>
                </div>
                <Button 
                    onClick={handleExport}
                    className="rounded-none border-2 border-primary bg-primary text-primary-foreground retro-btn text-xs uppercase tracking-widest" 
                    data-testid="export-subscribers-btn"
                    disabled={subscribers.length === 0}
                >
                    <Copy className="h-4 w-4 mr-2" />
                    Copy All Emails
                </Button>
            </div>

            {subscribers.length === 0 ? (
                <p className="text-muted-foreground text-center py-8">No subscribers yet. Share your page to grow your list!</p>
            ) : (
                <div className="space-y-2">
                    {subscribers.map(item => (
                        <div key={item.id} className="flex items-center justify-between p-4 border-2 border-border" data-testid={`subscriber-row-${item.id}`}>
                            <div className="flex items-center gap-4">
                                <div className="w-10 h-10 bg-primary/20 flex items-center justify-center">
                                    <Mail className="h-4 w-4 text-primary" />
                                </div>
                                <div>
                                    <p className="font-bold">{item.email}</p>
                                    <p className="text-xs text-muted-foreground">Subscribed {formatDate(item.subscribed_at)}</p>
                                </div>
                            </div>
                            <Button 
                                variant="outline" 
                                size="icon" 
                                onClick={() => handleDelete(item.id)} 
                                className="rounded-none border-2 text-destructive" 
                                data-testid={`delete-subscriber-${item.id}`}
                            >
                                <Trash2 className="h-4 w-4" />
                            </Button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
